import React, { useEffect, useState, useRef } from "react";
import "./index.scss";
import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Pagination,
  Modal,
  InputGroup,
  Form,
  Image,
} from "react-bootstrap";
import BackendLayout from "../../layouts/backend-layout";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import {
  getProductsAsync,
  productsResponse,
  addProductAsync,
  productAddResponse,
  updateProductAsync,
  productUpdateResponse,
  deleteProductAsync,
  productDeleteResponse,
  getShopCategoriesAsync,
  shopCategoriesResponse,
  resetAsync,
} from "../../api/slices/shop.slice";
import { toast } from "react-toastify";
import { API_ENDPOINTS } from "../../api/client/api.constants";
import JoditEditor from "jodit-react";

function Products(props) {
  const { setLoading } = props;
  const dispatch = useDispatch();

  const _productsResponse = useSelector(productsResponse);
  const _productUpdateResponse = useSelector(productUpdateResponse);
  const _productDeleteResponse = useSelector(productDeleteResponse);
  const _productAddResponse = useSelector(productAddResponse);
  const _shopCategoriesResponse = useSelector(shopCategoriesResponse);

  const [index, setIndex] = useState();
  const [page, setPage] = useState({
    page: 1,
    page_size: 15,
  });
  const [product, setProduct] = useState("");
  const [order_by, setOrderBy] = useState("DESC");
  const [query, setQuery] = useState();
  const [products, setProducts] = useState([]);
  const [paging, setPaging] = useState([]);
  const [categories, setCategories] = useState([]);

  const [showAddModel, setShowAddModel] = useState(false);
  const handleAddModelClose = () => {
    setShowAddModel(false);
  };
  const handleAddModelShow = () => {
    setProduct({});
    setShowAddModel(true);
  };

  const [showEditModel, setShowEditModel] = useState(false);
  const handleEditModelClose = () => {
    setShowEditModel(false);
  };
  const handleEditModelShow = (index) => {
    setIndex(index);
    setProduct(products[index]);
    setShowEditModel(true);
  };

  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const handleDeleteModelClose = () => {
    setShowDeleteModel(false);
  };
  const handleDeleteModelShow = (index) => {
    setIndex(index);
    setShowDeleteModel(true);
  };

  const hiddenMediaInput = useRef(null);
  const hiddenPDFInput = useRef(null);

  const hiddenJanuaryInput = useRef(null);
  const hiddenFebruaryInput = useRef(null);
  const hiddenMarchInput = useRef(null);
  const hiddenAprilInput = useRef(null);
  const hiddenMayInput = useRef(null);
  const hiddenJuneInput = useRef(null);
  const hiddenJulyInput = useRef(null);
  const hiddenAugustInput = useRef(null);
  const hiddenSeptemberInput = useRef(null);
  const hiddenOctoberInput = useRef(null);
  const hiddenNovemberInput = useRef(null);
  const hiddenDecemberInput = useRef(null);

  const editor = useRef(null);
  const config = {
    readonly: false,
    askBeforePasteFromWord: false,
    askBeforePasteHTML: false,
  };

  const columns = [
    { key: "id", value: "ID" },
    { key: "name", value: "Name" },
    { key: "category", value: "Category" },
    { key: "description", value: "Description" },
    { key: "price", value: "Price" },
    { key: "mmk_price", value: "MMK Price" },
    { key: "media", value: "Media" },
    { key: "created_at", value: "Created At" },
    { key: "active", value: "Active" },
    { key: "action", value: "Action" },
  ];

  useEffect(() => {
    dispatch(getProductsAsync({ page: page.page, page_size: page.page_size }));
    dispatch(getShopCategoriesAsync({ page: 1, page_size: 100 }));
  }, [page]);

  useEffect(() => {
    setLoading(_productsResponse.isLoading);
    if (
      _productsResponse.response &&
      _productsResponse.response.status === 200
    ) {
      window.scrollTo(0, 0);
      setProducts(_productsResponse.response.data.products);
      setPaging(_productsResponse.response.data.paging);
    } else {
      toast.error(_productsResponse.response?.message);
    }
  }, [_productsResponse]);

  useEffect(() => {
    setLoading(_productUpdateResponse.isLoading);
    if (
      _productUpdateResponse.response &&
      _productUpdateResponse.response.status === 200
    ) {
      setProduct({});
      dispatch(
        getProductsAsync({ page: page.page, page_size: page.page_size })
      );
    } else {
      toast.error(_productUpdateResponse.response?.message);
    }
  }, [_productUpdateResponse]);

  useEffect(() => {
    setLoading(_productAddResponse.isLoading);
    if (
      _productAddResponse.response &&
      _productAddResponse.response.status === 200
    ) {
      setProduct({});
      dispatch(
        getProductsAsync({ page: page.page, page_size: page.page_size })
      );
    } else {
      toast.error(_productAddResponse.response?.message);
    }
  }, [_productAddResponse]);

  useEffect(() => {
    setLoading(_productDeleteResponse.isLoading);
    if (
      _productDeleteResponse.response &&
      _productDeleteResponse.response.status === 200
    ) {
      setProduct({});
      dispatch(
        getProductsAsync({ page: page.page, page_size: page.page_size })
      );
    } else {
      toast.error(_productDeleteResponse.response?.message);
    }
  }, [_productDeleteResponse]);

  useEffect(() => {
    setLoading(_shopCategoriesResponse.isLoading);
    if (
      _shopCategoriesResponse.response &&
      _shopCategoriesResponse.response.status === 200
    ) {
      setCategories(_shopCategoriesResponse.response.data.categories);
    } else {
      toast.error(_shopCategoriesResponse.response?.message);
    }
  }, [_shopCategoriesResponse]);

  const onPageChange = (i) => {
    setPage({ ...page, page: i });
  };

  const onOrderClick = (key) => {
    const ignoreKey = ["action", "updated_at"];
    if (ignoreKey.includes(key)) {
      return;
    }
    const order = order_by == "DESC" ? "ASC" : "DESC";
    setOrderBy(order);
    dispatch(
      getProductsAsync({
        page: page.page,
        page_size: page.page_size,
        order_by: key,
        order,
      })
    );
  };

  const onQueryChange = (e) => {
    setQuery(e.target.value);
    if (e.target.value == "") {
      dispatch(
        getProductsAsync({
          page: page.page,
          page_size: page.page_size,
        })
      );
    }
  };

  const onSearch = () => {
    dispatch(
      getProductsAsync({
        page: page.page,
        page_size: page.page_size,
        search: query,
      })
    );
  };

  const onDelete = () => {
    setShowDeleteModel(false);
    const data = {
      id: products[index].id,
    };
    dispatch(deleteProductAsync(data));
  };

  const cleanProduct = () => {
    if (!product.link) delete product.link;
    if (product.is_has_pro) product.channel_link = product.channel_link.trim();
    else delete product.channel_link;
    product.is_downloadable = !product.is_has_pro && !!product.is_downloadable;
    product.points = Math.max(0, parseInt(product.points, 10) || 0);
  };

  const onAddProduct = () => {
    setShowAddModel(false);
    cleanProduct();
    dispatch(addProductAsync(product));
  };

  const onEditProduct = () => {
    setShowEditModel(false);
    cleanProduct();
    if (typeof product.media == "string") {
      delete product.media;
    }
    if (typeof product.link == "string") {
      delete product.link;
    }
    if (typeof product.january == "string") {
      delete product.january;
    }
    if (typeof product.february == "string") {
      delete product.february;
    }
    if (typeof product.march == "string") {
      delete product.march;
    }
    if (typeof product.april == "string") {
      delete product.april;
    }
    if (typeof product.may == "string") {
      delete product.may;
    }
    if (typeof product.june == "string") {
      delete product.june;
    }
    if (typeof product.july == "string") {
      delete product.july;
    }
    if (typeof product.august == "string") {
      delete product.august;
    }
    if (typeof product.september == "string") {
      delete product.september;
    }
    if (typeof product.october == "string") {
      delete product.october;
    }
    if (typeof product.november == "string") {
      delete product.november;
    }
    if (typeof product.december == "string") {
      delete product.december;
    }
    product.category_id = parseInt(product.category_id);
    delete product.created_at;
    delete product.category;
    dispatch(updateProductAsync(product));
  };

  const handleMediaClick = (event) => {
    hiddenMediaInput.current.click();
  };

  const handlePDFClick = (event) => {
    hiddenPDFInput.current.click();
  };

  const handleWorksheetClick = (event) => {
    switch (event.target.name) {
      case "january":
        hiddenJanuaryInput.current.click();
        break;
      case "february":
        hiddenFebruaryInput.current.click();
        break;
      case "march":
        hiddenMarchInput.current.click();
        break;
      case "april":
        hiddenAprilInput.current.click();
        break;
      case "may":
        hiddenMayInput.current.click();
        break;
      case "june":
        hiddenJuneInput.current.click();
        break;
      case "july":
        hiddenJulyInput.current.click();
        break;
      case "august":
        hiddenAugustInput.current.click();
        break;
      case "september":
        hiddenSeptemberInput.current.click();
        break;
      case "october":
        hiddenOctoberInput.current.click();
        break;
      case "november":
        hiddenNovemberInput.current.click();
        break;
      case "december":
        hiddenDecemberInput.current.click();
        break;
      default:
        break;
    }
  };

  const handleMediaChange = (event) => {
    const fileUploaded = event.target.files[0];
    setProduct({ ...product, media: fileUploaded });
  };

  const handlePDFChange = (event) => {
    const fileUploaded = event.target.files[0];
    setProduct({ ...product, link: fileUploaded });
  };

  const handleWorksheetChange = (event) => {
    switch (event.target.name) {
      case "january":
        const january = event.target.files[0];
        setProduct({ ...product, january: january });
        break;
      case "february":
        const february = event.target.files[0];
        setProduct({ ...product, february: february });
        break;
      case "march":
        const march = event.target.files[0];
        setProduct({ ...product, march: march });
        break;
      case "april":
        const april = event.target.files[0];
        setProduct({ ...product, april: april });
        break;
      case "may":
        const may = event.target.files[0];
        setProduct({ ...product, may: may });
        break;
      case "june":
        const june = event.target.files[0];
        setProduct({ ...product, june: june });
        break;
      case "july":
        const july = event.target.files[0];
        setProduct({ ...product, july: july });
        break;
      case "august":
        const august = event.target.files[0];
        setProduct({ ...product, august: august });
        break;
      case "september":
        const september = event.target.files[0];
        setProduct({ ...product, september: september });
        break;
      case "october":
        const october = event.target.files[0];
        setProduct({ ...product, october: october });
        break;
      case "november":
        const november = event.target.files[0];
        setProduct({ ...product, november: november });
        break;
      case "december":
        const december = event.target.files[0];
        setProduct({ ...product, december: december });
        break;
      default:
        break;
    }
  };

  const handleActiveChange = (index) => {
    setIndex(index);
    dispatch(
      updateProductAsync({
        id: products[index].id,
        active: !products[index].active,
      })
    );
  };

  return (
    <React.Fragment>
      <Row>
        <Col md="12">
          <Card>
            <Card.Header>
              Products
              <p className="text-muted">All Products</p>
            </Card.Header>
            <Card.Body>
              <Row className="ml-1">
                <Col>
                  <span
                    onClick={handleAddModelShow}
                    to="#ecommerce-add"
                    className="btn btn-primary btn-rounded box-shadow btn-icon"
                  >
                    <i className="fa fa-plus" /> Add Products
                  </span>
                </Col>
                <Col md="auto">
                  <div className="mb-2">
                    <InputGroup>
                      <Form.Control
                        value={query}
                        onChange={onQueryChange}
                        type="text"
                        placeholder="Search"
                      />
                      <div className="input-group-btn">
                        <Button variant="primary" onClick={onSearch}>
                          <i className="fa fa-search" />
                        </Button>
                      </div>
                    </InputGroup>
                  </div>
                </Col>
              </Row>

              <div className="table-responsive">
                <Table
                  id="datatable1"
                  striped="columns"
                  className="table table-striped table-hover mt-4"
                >
                  <thead>
                    <tr>
                      {columns.map((item) => {
                        return (
                          <th
                            role="button"
                            className="text-center"
                            onClick={() => onOrderClick(item.key)}
                          >
                            <Row className="justify-content-md-center ml-2 mr-2">
                              <strong>{item.value}</strong>
                            </Row>
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((item, i) => {
                      return (
                        <tr className="text-center">
                          <td>{item.id}</td>
                          <td>{item.name}</td>
                          <td>{item.category.name}</td>
                          {/* <td ><span dangerouslySetInnerHTML={{ __html: item.description.length >= 40 ? item.description.match(/I((\s*\S+){40})([\s\S]*)/)[1] : item.description }}></span></td> */}
                          <td>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></span>
                          </td>
                          <td>{item.price}</td>
                          <td>{item.mmk_price}</td>
                          <td>
                            <Image
                              fluid
                              width={50}
                              height={50}
                              alt="#"
                              src={`${API_ENDPOINTS.IMAGE}${item.media}`}
                            />
                          </td>
                          <td>{item.created_at}</td>
                          <td>
                            <div className="custom-control custom-switch">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`switch_${i}`}
                                checked={item.active}
                                readOnly
                                onChange={() => {
                                  handleActiveChange(i);
                                }}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`switch_${i}`}
                              />
                            </div>
                          </td>
                          <td nowrap="nowrap" className="text-center">
                            <Button
                              variant="success"
                              size="sm"
                              onClick={() => handleEditModelShow(i)}
                            >
                              <i className="fa fa-edit" />
                            </Button>{" "}
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={() => handleDeleteModelShow(i)}
                            >
                              <i className="fa fa-trash" />
                            </Button>{" "}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
              <Pagination>
                {Array.from({ length: paging.total_pages }).map((item, i) => {
                  return (
                    <Pagination.Item
                      onClick={() => onPageChange(i + 1)}
                      key={i}
                      active={i + 1 === paging.currentPage}
                    >
                      {i + 1}
                    </Pagination.Item>
                  );
                })}
              </Pagination>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal size="lg" show={showEditModel} onHide={handleEditModelClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Control
                  style={{ marginBottom: "15px" }}
                  value={product.name}
                  onChange={(e) => {
                    setProduct({ ...product, name: e.target.value });
                  }}
                  type="text"
                  placeholder="Name"
                />

                <Form.Label >Description</Form.Label>
                <div style={{ marginBottom: "15px" }}>
                  <JoditEditor
                    ref={editor}
                    value={product.description}
                    config={config}
                    tabIndex={1}
                    onBlur={(newContent) =>
                      setProduct({ ...product, description: newContent })
                    }
                  />
                </div>

                <Form.Label>Price</Form.Label>
                <Form.Control
                  style={{ marginBottom: "15px" }}
                  value={product.price}
                  onChange={(e) => {
                    setProduct({ ...product, price: e.target.value });
                  }}
                  type="number"
                  placeholder="Price"
                />

                <Form.Label>MMK Price</Form.Label>
                <Form.Control
                  style={{ marginBottom: "15px" }}
                  value={product.mmk_price}
                  onChange={(e) => {
                    setProduct({ ...product, mmk_price: e.target.value });
                  }}
                  type="number"
                  placeholder="MMK Price"
                />

                <Form.Label>Points (optional)</Form.Label>
                <Form.Control
                  style={{ marginBottom: "15px" }}
                  value={product.points ?? ""}
                  onChange={(e) => {
                    setProduct({ ...product, points: e.target.value });
                  }}
                  type="number"
                  min="0"
                  step="1"
                  placeholder="Points user earns on purchase (default 0)"
                />

                <Form.Label>Category</Form.Label>
                <Form.Control
                  as="select"
                  style={{ marginBottom: "15px" }}
                  value={product.category_id}
                  onChange={(e) => {
                    setProduct({ ...product, category_id: e.target.value });
                  }}
                >
                  <option value={"PLACEHOLDER"}>Select Category</option>
                  {categories.map((item) => {
                    return <option value={item.id}> {item.name}</option>;
                  })}
                </Form.Control>

                <Form.Group
                  controlId={`has-pro-version-${showEditModel ? "edit" : "add"}`}
                  style={{ marginBottom: "15px" }}
                >
                  <Form.Check
                    type="switch"
                    label="Has Pro Version"
                    checked={!!product.is_has_pro}
                    onChange={(e) =>
                      setProduct({
                        ...product,
                        is_has_pro: e.target.checked,
                        ...(e.target.checked && { is_downloadable: false }),
                      })
                    }
                  />
                </Form.Group>

                {!!product.is_has_pro && (
                  <>
                    <Form.Label>Channel Link</Form.Label>
                    <Form.Control
                      value={product.channel_link || ""}
                      style={{ marginBottom: "15px" }}
                      onChange={(e) =>
                        setProduct({ ...product, channel_link: e.target.value })
                      }
                      type="text"
                      placeholder="Channel Link"
                    />
                  </>
                )}

                {!product.is_has_pro && (
                  <Form.Group
                    controlId={`is-downloadable-${showEditModel ? "edit" : "add"}`}
                    style={{ marginBottom: "15px" }}
                  >
                    <Form.Check
                      type="switch"
                      label="Is Downloadable"
                      checked={!!product.is_downloadable}
                      onChange={(e) =>
                        setProduct({
                          ...product,
                          is_downloadable: e.target.checked,
                        })
                      }
                    />
                  </Form.Group>
                )}

                <Form.Label>Product Image</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="Product Image"
                    value={
                      typeof product.media == "string"
                        ? product.media
                        : product.media?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      onClick={handleMediaClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  onChange={handleMediaChange}
                  ref={hiddenMediaInput}
                  style={{ display: "none" }}
                />

                <Form.Label>Journal PDF</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="PDF"
                    value={
                      typeof product.link == "string"
                        ? product.link
                        : product.link?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      onClick={handlePDFClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handlePDFChange}
                  ref={hiddenPDFInput}
                  style={{ display: "none" }}
                />

                <Form.Label>January Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="January Journal"
                    value={
                      typeof product.january == "string"
                        ? product.january
                        : product.january?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="january"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="january"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenJanuaryInput}
                  style={{ display: "none" }}
                />

                <Form.Label>February Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="February Journal"
                    value={
                      typeof product.february == "string"
                        ? product.february
                        : product.february?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="february"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="february"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenFebruaryInput}
                  style={{ display: "none" }}
                />

                <Form.Label>March Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="March Journal"
                    value={
                      typeof product.march == "string"
                        ? product.march
                        : product.march?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="march"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="march"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenMarchInput}
                  style={{ display: "none" }}
                />

                <Form.Label>April Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="April Journal"
                    value={
                      typeof product.april == "string"
                        ? product.april
                        : product.april?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="april"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="april"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenAprilInput}
                  style={{ display: "none" }}
                />

                <Form.Label>May Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="May Journal"
                    value={
                      typeof product.may == "string"
                        ? product.may
                        : product.may?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="may"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="may"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenMayInput}
                  style={{ display: "none" }}
                />

                <Form.Label>June Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="June Journal"
                    value={
                      typeof product.june == "string"
                        ? product.june
                        : product.june?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="june"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="june"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenJuneInput}
                  style={{ display: "none" }}
                />

                <Form.Label>July Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="July Journal"
                    value={
                      typeof product.july == "string"
                        ? product.july
                        : product.july?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="july"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="july"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenJulyInput}
                  style={{ display: "none" }}
                />

                <Form.Label>August Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="August Journal"
                    value={
                      typeof product.august == "string"
                        ? product.august
                        : product.august?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="august"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="august"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenAugustInput}
                  style={{ display: "none" }}
                />

                <Form.Label>September Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="September Journal"
                    value={
                      typeof product.september == "string"
                        ? product.september
                        : product.september?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="september"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="september"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenSeptemberInput}
                  style={{ display: "none" }}
                />

                <Form.Label>October Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="October Journal"
                    value={
                      typeof product.october == "string"
                        ? product.october
                        : product.october?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="october"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="october"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenOctoberInput}
                  style={{ display: "none" }}
                />

                <Form.Label>November Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="November Journal"
                    value={
                      typeof product.november == "string"
                        ? product.november
                        : product.november?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="november"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="november"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenNovemberInput}
                  style={{ display: "none" }}
                />

                <Form.Label>December Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="December Journal"
                    value={
                      typeof product.december == "string"
                        ? product.december
                        : product.december?.name
                    }
                  />
                  <InputGroup.Append>
                    <Button
                      name="december"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="december"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenDecemberInput}
                  style={{ display: "none" }}
                />


              </Form.Group>
            </Col>
          </Row>
          <br />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleEditModelClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              if (!product.name || product.name == "") {
                toast.error("Please enter name");
              } else if (!product.description || product.description == "") {
                toast.error("Please enter product description");
              } else if (!product.price || product.price == "") {
                toast.error("Please enter product price");
              } else if (!product.mmk_price || product.mmk_price == "") {
                toast.error("Please enter product MMK price");
              } else if (!product.category_id || product.category_id == "") {
                toast.error("Please select product category");
              } else if (!product.media) {
                toast.error("Please select product media");
              } else if (!product.is_has_pro && !product.link) {
                toast.error("Please select product PDF");
              } else if (
                product.is_has_pro &&
                !(product.channel_link || "").trim()
              ) {
                toast.error("Please enter channel link");
              } else {
                onEditProduct();
              }
            }}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="lg" show={showAddModel} onHide={handleAddModelClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Control
                  value={product.name}
                  style={{ marginBottom: "15px" }}
                  onChange={(e) => {
                    setProduct({ ...product, name: e.target.value });
                  }}
                  type="text"
                  placeholder="Name"
                />

                <Form.Label>Description</Form.Label>
                <div style={{ marginBottom: "15px" }}>
                  <JoditEditor
                    ref={editor}
                    value={product.description}
                    config={config}
                    tabIndex={1}
                    onBlur={(newContent) =>
                      setProduct({ ...product, description: newContent })
                    }
                  />
                </div>

                <Form.Label>Price</Form.Label>
                <Form.Control
                  style={{ marginBottom: "15px" }}
                  value={product.price}
                  onChange={(e) => {
                    setProduct({ ...product, price: e.target.value });
                  }}
                  type="number"
                  placeholder="Price"
                />

                <Form.Label>MMK Price</Form.Label>
                <Form.Control
                  style={{ marginBottom: "15px" }}
                  value={product.mmk_price}
                  onChange={(e) => {
                    setProduct({ ...product, mmk_price: e.target.value });
                  }}
                  type="number"
                  placeholder="MMK Price"
                />

                <Form.Label>Points (optional)</Form.Label>
                <Form.Control
                  style={{ marginBottom: "15px" }}
                  value={product.points ?? ""}
                  onChange={(e) => {
                    setProduct({ ...product, points: e.target.value });
                  }}
                  type="number"
                  min="0"
                  step="1"
                  placeholder="Points user earns on purchase (default 0)"
                />

                <Form.Label>Category</Form.Label>
                <Form.Control
                  as="select"
                  style={{ marginBottom: "15px" }}
                  value={product.category_id}
                  onChange={(e) => {
                    setProduct({ ...product, category_id: e.target.value });
                  }}
                >
                  <option value={"PLACEHOLDER"}>Select Category</option>
                  {categories.map((item) => {
                    return <option value={item.id}> {item.name}</option>;
                  })}
                </Form.Control>

                <Form.Group
                  controlId={`has-pro-version-${showEditModel ? "edit" : "add"}`}
                  style={{ marginBottom: "15px" }}
                >
                  <Form.Check
                    type="switch"
                    label="Has Pro Version"
                    checked={!!product.is_has_pro}
                    onChange={(e) =>
                      setProduct({
                        ...product,
                        is_has_pro: e.target.checked,
                        ...(e.target.checked && { is_downloadable: false }),
                      })
                    }
                  />
                </Form.Group>

                {!!product.is_has_pro && (
                  <>
                    <Form.Label>Channel Link</Form.Label>
                    <Form.Control
                      value={product.channel_link || ""}
                      style={{ marginBottom: "15px" }}
                      onChange={(e) =>
                        setProduct({ ...product, channel_link: e.target.value })
                      }
                      type="text"
                      placeholder="Channel Link"
                    />
                  </>
                )}

                {!product.is_has_pro && (
                  <Form.Group
                    controlId={`is-downloadable-${showEditModel ? "edit" : "add"}`}
                    style={{ marginBottom: "15px" }}
                  >
                    <Form.Check
                      type="switch"
                      label="Is Downloadable"
                      checked={!!product.is_downloadable}
                      onChange={(e) =>
                        setProduct({
                          ...product,
                          is_downloadable: e.target.checked,
                        })
                      }
                    />
                  </Form.Group>
                )}

                <Form.Label>Product Image</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="Product Image"
                    value={product.media?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      onClick={handleMediaClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  onChange={handleMediaChange}
                  ref={hiddenMediaInput}
                  style={{ display: "none" }}
                />

                <Form.Label>Journal PDF</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="PDF"
                    value={product.link?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      onClick={handlePDFClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handlePDFChange}
                  ref={hiddenPDFInput}
                  style={{ display: "none" }}
                />

                <Form.Label>January Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="January Journal"
                    value={product.january?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="january"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="january"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenJanuaryInput}
                  style={{ display: "none" }}
                />

                <Form.Label>February Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="February Journal"
                    value={product.february?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="february"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="february"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenFebruaryInput}
                  style={{ display: "none" }}
                />

                <Form.Label>March Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="March Journal"
                    value={product.march?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="march"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="march"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenMarchInput}
                  style={{ display: "none" }}
                />

                <Form.Label>April Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="April Journal"
                    value={product.april?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="april"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="april"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenAprilInput}
                  style={{ display: "none" }}
                />

                <Form.Label>May Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="May Journal"
                    value={product.may?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="may"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="may"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenMayInput}
                  style={{ display: "none" }}
                />

                <Form.Label>June Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="June Journal"
                    value={product.june?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="june"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="june"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenJuneInput}
                  style={{ display: "none" }}
                />

                <Form.Label>July Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="July Journal"
                    value={product.july?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="july"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="july"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenJulyInput}
                  style={{ display: "none" }}
                />

                <Form.Label>August Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="August Journal"
                    value={product.august?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="august"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="august"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenAugustInput}
                  style={{ display: "none" }}
                />

                <Form.Label>September Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="September Journal"
                    value={product.september?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="september"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="september"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenSeptemberInput}
                  style={{ display: "none" }}
                />

                <Form.Label>October Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="October Journal"
                    value={product.october?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="october"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="october"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenOctoberInput}
                  style={{ display: "none" }}
                />

                <Form.Label>November Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="November Journal"
                    value={product.november?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="november"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="november"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenNovemberInput}
                  style={{ display: "none" }}
                />

                <Form.Label>December Journal</Form.Label>
                <InputGroup style={{ marginBottom: "15px" }}>
                  <Form.Control
                    disabled
                    placeholder="December Journal"
                    value={product.december?.name}
                  />
                  <InputGroup.Append>
                    <Button
                      name="december"
                      onClick={handleWorksheetClick}
                      variant="outline-secondary"
                    >
                      Choose
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

                <input
                  type="file"
                  name="december"
                  accept="application/pdf, application/vnd.ms-excel"
                  onChange={handleWorksheetChange}
                  ref={hiddenDecemberInput}
                  style={{ display: "none" }}
                />

              </Form.Group>
            </Col>
          </Row>
          <br />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleAddModelClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              if (!product.name || product.name == "") {
                toast.error("Please enter name");
              } else if (!product.description || product.description == "") {
                toast.error("Please enter product description");
              } else if (!product.price || product.price == "") {
                toast.error("Please enter product price");
              } else if (!product.mmk_price || product.mmk_price == "") {
                toast.error("Please enter product MMK price");
              } else if (!product.category_id || product.category_id == "") {
                toast.error("Please select product category");
              } else if (!product.media) {
                toast.error("Please select product media");
              } else if (!product.is_has_pro && !product.link) {
                toast.error("Please select product PDF");
              } else if (
                product.is_has_pro &&
                !(product.channel_link || "").trim()
              ) {
                toast.error("Please enter channel link");
              } else {
                onAddProduct();
              }
            }}
          >
            Add
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteModel} onHide={handleDeleteModelClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete.?</p>
          <br />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModelClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={(e) => {
              onDelete();
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
export default BackendLayout(Products);
